var _defs, _use, _use2, _use3, _use4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgShip = function SvgShip(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L24 0L24 24L0 24L0 0Z",
    id: "cxQXtYjWa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.11 5.72L11.11 3.23C5.88 3.23 2.98 3.23 2.4 3.23C1.71 3.23 1.15 3.79 1.15 4.47C1.15 4.93 1.15 7.21 1.15 11.32C1.9 11.32 2.31 11.32 2.4 11.32C2.4 12.36 3.23 13.19 4.26 13.19C5.3 13.19 6.13 12.36 6.13 11.32C6.51 11.32 9.49 11.32 9.87 11.32C9.87 12.36 10.7 13.19 11.74 13.19C12.77 13.19 13.6 12.36 13.6 11.32C13.69 11.32 14.1 11.32 14.85 11.32L14.85 8.21L12.98 5.72L11.11 5.72ZM3.33 11.32C3.33 10.81 3.75 10.39 4.26 10.39C4.78 10.39 5.2 10.81 5.2 11.32C5.2 11.84 4.78 12.26 4.26 12.26C3.75 12.26 3.33 11.84 3.33 11.32ZM13.89 8.21L11.11 8.21L11.11 6.65L12.67 6.65L13.89 8.21ZM10.8 11.32C10.8 10.81 11.22 10.39 11.74 10.39C12.25 10.39 12.67 10.81 12.67 11.32C12.67 11.84 12.25 12.26 11.74 12.26C11.22 12.26 10.8 11.84 10.8 11.32Z",
    id: "doP1Fxt3m"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cxQXtYjWa",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 0
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cxQXtYjWa",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#doP1Fxt3m",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#doP1Fxt3m",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShip, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ship.97ad5c76.svg";
export { ForwardRef as ReactComponent };